import { Flex, Portal, Text, keyframes } from '@chakra-ui/react';

const dotAnimation = keyframes`
  0%, 20%  { content: '.';   }
  40%      { content: '..';  }
  60%      { content: '...'; }
  80%, 100%{ content: '';    }
`;

const SpinnerCenter = () => {
    return (
        <Portal>
            <Flex
                position="fixed"
                top="0"
                left="0"
                width="100vw"
                height="100vh"
                zIndex="9999"
                bg="blackAlpha.600"
                cursor="wait"
                justify="center"
                align="center"
            >
                <Flex direction="column" align="center" gap={4}>
                    <img src="/favicon.svg" width={200} />
                    <Text fontSize={24} fontWeight={500} color="white">
                        Carregando
                        <Text
                            as="span"
                            display="inline-block"
                            w="1.5ch"
                            textAlign="left"
                            _after={{
                                content: "''",
                                animation: `${dotAnimation} 1.5s steps(1) infinite`,
                            }}
                        />
                    </Text>
                </Flex>
            </Flex>
        </Portal>
    );
};

export default SpinnerCenter;
